import React from 'react';
import Page from '@Containers/Page';
import { LinkElement } from '@els/els-react--link-element';
import SUPPORT_CENTER_LINK from './MaintenanceConstants';

function Maintenance() {
  return (
    <Page
      withHeader
      headerType="clean"
      withFooter
      pageClassName="react-page-static maintenance-page"
      className="react-page-static__wrapper">
      <h1 className="react-page-static__heading">
        <span className="ss-mug" />
        &nbsp; Page Under Maintenance
      </h1>
      <div className="react-page-static__content">
        <p>
          We apologize for inconvenience. This service is unavailable due to a server update. We expect to be back soon.
          <br />
          Thanks for your patience.
        </p>
        <p>Please contact our support team if you have any questions</p>
        <p>
          <LinkElement
            data-e2e="contact-support-team"
            href={SUPPORT_CENTER_LINK}
            className="e2e-contact-support-team"
            isExternal
            iconSprite="ChevronRight"
            iconSize="s"
            iconRight>
            Contact Support Team
          </LinkElement>
        </p>
      </div>
    </Page>
  );
}

export default Maintenance;
